import BCComponent from "./bc_component";
import {bindActionCreators} from "redux";
import {getBonusTasks, submitBonusTask} from "game/app/actions/bonus-tasks-actions";
import connect from "react-redux/es/connect/connect";
import React from "react";

class Oblast3 extends BCComponent {

    render() {
        return (
            <div>
                <h1>INTERNET A OBRÁZKY</h1>
                <div className='separate-bottom'>
                    <p>Internet je dnes cenným zdrojem informací, najdeme na něm odpovědi na spoustu otázek. Problém je, že někdy je informací příliš mnoho a není jednoduché se v nich zorientovat. V orientaci na internetu pomáhají různé grafické prvky, kterými je možné obohatit a zvýraznit obsah sdělení. Každá firma / projekt má své logo, weby jsou plné ikon, obrázků a fotografií, ale také moderních prvků, jako je upoutávka nebo komix, infografika apod.</p>
                    <p>Schématické uspořádání informací či používání různých symbolů nám umožňuje lépe informace vnímat a déle si je pamatovat. Když pak takový grafický výtvor sami vytváříme, rozvíjí nám to další schopnosti, protože si musíme sami uspořádat informace a zamyslet se nad tím, co chceme vyjádřit (a předat dál).</p>
                </div>

                { this.showTask("zs_internet_1") }
                { this.showTask("zs_internet_2") }
            </div>
        );
    }
}

function mapStateToProps(state,ownProps) {
    return {
        bonusTasks: state.bonusTasks,
        gameInstance: state.gameInstance
    };
}

function matchDispatchToProps(dispatch){
    return bindActionCreators({
        getBonusTasks: getBonusTasks,
        submitBonusTask: submitBonusTask
    }, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)(Oblast3);
